export default "__VITE_ASSET__CU4cm4dG__"